// @flow
import * as React from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'
import {
  Banner,
  Button,
  Choose,
  CodeSample,
  Link,
  Section,
  SplitSection,
  Toggle,
  Trait,
  Traits,
  styles
} from 'tutellus-ui'

import {apiExamples} from './api_examples.js'

import {Page} from './Page'

const TriggerButton = styled(Button)`
    margin: 0;
    margin-right: 1em;
`
const CodeOutput = styled(CodeSample)``
CodeOutput.displayName = 'CodeOutput'
const LanguageSelector = styled.div``
LanguageSelector.displayName = 'LanguageSelector'
const LiveTest = styled(translate('affiliateApi')(({className, t}) =>
  <div className={className}>
    <p>{ t('livetest_description') }</p>
    <Choose options={apiExamples}>{ (selected, choose) =>
      <React.Fragment>
        <CodeSample lang={selected.language}>
          { selected.code }
        </CodeSample>
        <Toggle>{ (showOutput, mockApi) =>
          <React.Fragment>
            <span>
              <TriggerButton secondary onClick={mockApi}>{
                showOutput ? t('clear_output')
                  : t('test_it_out')
              }</TriggerButton>
              <small>{ t('trigger_hint') }</small>
            </span>

            { showOutput &&
            <CodeOutput>
              { selected.output }
            </CodeOutput>
            }
          </React.Fragment>
        }</Toggle>
        <LanguageSelector>
          <strong>{ t('choose_a_language') }</strong>
          <ul>{
            apiExamples.map(example =>
              <li key={example.name} onClick={() => choose(example)}>
                <span>{ example.name }</span>
              </li>
            )
          }</ul>
          <hr />
          <small><a href={t('urls:affiliate')}>{ t('view_api_docs') }</a></small>
        </LanguageSelector>
      </React.Fragment>
    }</Choose>
  </div>
))`
    display: grid;
    grid: "selector"
          "p"
          "code"
          "controls"
          "output"
          / 1fr;
    @media ${styles.media.tablet} {
      grid: "p             p           selector"
            "code         code        selector"
            "controls     controls    controls"
            "output       output      output"
            /    1fr         1fr         0.8fr;
    }
    align-items: start;
    grid-gap: 1em;
    text-align: left;

    & > p {grid-area: p;}
    & > ${CodeSample} { grid-area: code; }
    & > ${LanguageSelector} {
      grid-area: selector;
      & small {
        & a {
            color: ${styles.colors.title_decoration};
            text-decoration: none;
        }
      }
      & hr {
        border: 0;
        border-top: 1px solid ${styles.colors.lightborder};
        width: 100%;
      }
      & ul {
          margin: 1em 0 0;
          padding: 0;
          list-style: none;
          & li {
              line-height: 2em;
              & span {
                  cursor: pointer;
                  color: ${styles.colors.title_decoration};
              }
          }
      }
    }
    & > span { grid-area: controls; }
    & > ${CodeOutput} { grid-area: output; }

    & p { margin: 0; }
    & ${TriggerButton} {
      margin-bottom: 0.5em;
      @media ${styles.media.tablet} {
        margin-bottom: 0;
      }
    }
`

const BenefitSection = styled(Section)`
  & ${Traits} {
    @media ${styles.media.tablet} {
      grid-template-columns: repeat(2,1fr);
    }
    @media ${styles.media.laptop} {
      grid-template-columns: repeat(4,1fr);
    }
    margin-bottom: 2em;
  }
`
BenefitSection.displayName = 'BenefitSection'

const AccessSection = styled(Section)`
  & small {
    & a {
      color: ${styles.colors.title_decoration};
    }
  }
`
AccessSection.displayName = 'AccessSection'

export const AffiliateApi = translate('affiliateApi')(({t}) =>
  <Page>
    <Banner title={t('title')}
      background_url={t('background_url')}>
      <p>{ t('description') }</p>
      <Link button primary
        href={t('urls:affiliate')}
      >
        { t('get_access') }
      </Link>
    </Banner>
    <BenefitSection title={t('reasons_title')}>
      <Traits>{
        JSON.parse(t('reasons')).map(reason =>
          <Trait key={reason}
            title={t(`${reason}_title`)}
            icon={t(`${reason}_icon`)}>
            { t(`${reason}_description`) }
          </Trait>
        )
      }</Traits>
      <Link button primary
        href={t('urls:register')}
      >
        { t('become_affiliate') }
      </Link>
    </BenefitSection>
    <SplitSection dark
      title={t('metrics_title')}
      image={t('metrics_image')}>
      <p>{ t('metrics_description') }</p>
    </SplitSection>
    <Section title={t('livetest_title')}>
      <LiveTest />
    </Section>
    <Section light title={t('features_title')}>
      <Traits>{
        JSON.parse(t('features')).map(feature =>
          <Trait key={feature}
            title={t(`${feature}_title`)}
            image={t(`${feature}_image`)}>
            { t(`${feature}_description`) }
          </Trait>
        )
      }</Traits>
    </Section>
    <AccessSection title={t('get_access_title')} >
      <p>
        <Link button primary
          href={t('urls:affiliate')}
        >
          { t('get_access') }
        </Link>
      </p>
      <small>
        <Link href={t('urls:affiliate_terms')}>
          { t('terms') }
        </Link>
      </small>
    </AccessSection>
  </Page>
)
AffiliateApi.displayName = 'AffiliateApi'



// WEBPACK FOOTER //
// ./src/pages/AffiliateApi.js